import request from 'utils/RequestManager';

import config from '../../config';

const authURL = config.AUTH_HOST;
const chatBackendURL = config.BACKEND_HOST;

export function fetchCompany() {
    return request({
        method: 'GET',
        baseURL: authURL,
        url: '/companies/',
    }).then(response => response.data);
}

export function fetchCompanyMembers() {
    return request({
        method: 'GET',
        baseURL: authURL,
        url: '/users',
    }).then(res => res.data);
}

export function updateCompany(companyId, update) {
    return request({
        method: 'PUT',
        baseURL: authURL,
        url: `/companies/${companyId}/`,
        data: update,
    }).then(response => response.data);
}

export function updateClientName(companyId, name) {
    return request({
        method: 'PUT',
        baseURL: authURL,
        url: `/companies/name/${companyId}/?companyName=${name}`,
    }).then(response => response.data);
}

export function inviteMember(memberInfo) {
    return request({
        method: 'POST',
        baseURL: authURL,
        url: '/invite',
        data: memberInfo,
    }).then(response => response.data);
}

export function reInviteMember(memberId) {
    return request({
        method: 'POST',
        baseURL: authURL,
        url: `/users/${memberId}/re-invite`,
    }).then(response => response.data);
}

export function inviteMemberWithParams(objData) {
    return request({
        method: 'POST',
        baseURL: authURL,
        url: '/invite-with-params',
        data: objData,
    }).then(response => response.data);
}

export function removeMembers(memberList) {
    const membersUpdate = memberList.map(member => ({
        id: member.id,
        status: config.statusMap.deleted,
        subCompanyIds: member.subCompanyIds,
    }));
    return updateMemberList(membersUpdate);
}

export function createClient(clientData) {
    return request({
        method: 'POST',
        baseURL: authURL,
        url: '/companies',
        data: clientData,
    }).then(response => response.data);
}

export function cloneClient(clientData, originalCompanyId) {
    return request({
        method: 'POST',
        baseURL: authURL,
        url: '/companies/clone',
        data: clientData,
        params: {
            originalSubCompanyId: originalCompanyId
        }
    }).then(response => response.data);
}

export function addMembersToClients(members, clients) {
    const membersUpdate = members.map((member) => {
        const subs = [...member.subCompanyIds];
        clients.forEach((client) => {
            if (!subs.includes(client.id)) {
                subs.push(client.id);
            }
        });
        return {
            id: member.id,
            status: member.status,
            subCompanyIds: subs,
        };
    });

    return updateMemberList(membersUpdate);
}

export function removeMembersFromClients(members, clients) {
    const clientsIds = clients.map(client => client.id);
    const membersUpdate = members.map((member) => {
        const subs = member.subCompanyIds.filter(id => !clientsIds.includes(id));

        return {
            id: member.id,
            status: member.status,
            subCompanyIds: subs,
        };
    });

    return updateMemberList(membersUpdate);
}

export function updateMemberList(membersUpdate) {
    return request({
        method: 'PUT',
        baseURL: authURL,
        url: '/users',
        data: {
            users: membersUpdate,
        },
    }).then(response => response.data);
}

export function updateMemberRole2(membersUpdate) {
    return request({
        method: 'PUT',
        baseURL: authURL,
        url: `/users/role/${membersUpdate[0].id}/${membersUpdate[0].authorities[0]}`,
    }).then(response => response.data);
}

export function updateMemberCurrentStatus(memberUpdate) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: `/operators/update/current-status/${memberUpdate.id}/${memberUpdate.currentStatus}`,

    }).then(response => response.data);
}

export function updateMemberChatLimit(platformId, chatLimit) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: `/operators/update/chat-limit/${platformId}/${chatLimit}`,
    }).then(response => response.data);
}

export function changeUserPasswordForOwner(platformId, newPassword) {
    return request({
        method: 'POST',
        baseURL: authURL,
        url: `/user/change-password/for-owner`,
        params: {
            userId: platformId
        },
        headers: {
            'Content-Type': 'text/plain'
        },
        data: newPassword
    }).then(response => response.data);
}

export function updateMemberCurrentChatLimit(platformId, chatLimit) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: `/operators/update/current-chat-limit/${platformId}/${chatLimit}`,
    }).then(response => response.data);
}

export function updateOperatorCurrentStatus(platformId, status) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: `/operators/update/current-status/${platformId}/${status}`,
    }).then(response => response.data);
}

export function getClientHardcodedMessages(clientId) {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/hardcoded/${clientId}`,
    }).then(response => response.data);
}

export function getClientHardcodedMessageStatusData(clientId) {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/hardcoded/status/${clientId}`,
    }).then(response => response.data);
}

export function updateHardcodedMessageStatus(clientId, type, status) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: `/hardcoded/status/${clientId}`,
        params: {
            type,
            status
        },
    }).then(response => response.data);
}

export function editCompanyAutoConnectType(clientId, type) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: `/auto-connect/type/${clientId}/${type}`,
    }).then(response => response.data);
}

export function editCompanyAutoConnectNotFoundType(clientId, type) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: `/auto-connect/not-found-type/${clientId}/${type}`,
    }).then(response => response.data);
}

export function updateAutoConnectStatus(clientId, isChecked) {
    const url = `/auto-connect/${clientId}/${isChecked ? 'false' : 'true'}`;
    return request({
        method: 'POST',
        baseURL: chatBackendURL,
        url,
    }).then(response => response.data);
}

export function getAutoConnectStatus(clientId) {
    const url = `/auto-connect/${clientId}`;
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url,
    }).then(response => response.data);
}

export function getForbiddenWords(clientId) {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/forbidden-words/${clientId}`,
    }).then(response => response.data);
}

export function addForbiddenWord(clientId, words) {
    return request({
        method: 'POST',
        baseURL: chatBackendURL,
        url: `/forbidden-words/${clientId}`,
        data: words
    }).then(response => response.data);
}

export function downloadFileWithWords(clientId) {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        responseType: 'blob',
        url: `/forbidden-words/download/${clientId}`,
    }).then((response) => {
        if (response.data) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'forbidden_words.txt');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        } else {
            console.error('The response data is undefined or null.');
        }
    });
}

export function deleteForbiddenWord(clientId, word) {
    return request({
        method: 'DELETE',
        baseURL: chatBackendURL,
        url: `/forbidden-words/${clientId}?text=${word}`,
    }).then(response => response.data);
}

export function deleteAllForbiddenWordsByCompany(clientId) {
    return request({
        method: 'DELETE',
        baseURL: chatBackendURL,
        url: `/forbidden-words/all/${clientId}`,
    }).then(response => response.data);
}

export function getClientWebChatConf(clientId) {
    return request({
        method: 'GET',
        baseURL: authURL,
        url: `/companies/${clientId}/web-chat-configs`,
    }).then(response => response.data);
}

export function getCompanyTextAction(clientId) {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/text-action/${clientId}`,
    }).then(response => response.data);
}

export function editCompanyTextAction(clientId, type) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: `/text-action/${clientId}/${type}`,
    }).then(response => response.data);
}

export function getCompanyConvVis(clientId) {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/conversation-visibility/${clientId}`,
    }).then(response => response.data);
}

export function editCompanyConvVis(clientId, type) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: `/conversation-visibility/${clientId}/${type}`,
    }).then(response => response.data);
}

export function updateClientWebChatConf(id, data) {
    return request({
        method: 'PUT',
        data,
        baseURL: authURL,
        url: `/web-chat-configs/${id}`,
    }).then(response => response.data);
}

export function updateClientWebChatColorsConf(id, data) {
    return request({
        method: 'PUT',
        data,
        baseURL: authURL,
        url: `/web-chat-configs/colors/${id}`,
    }).then(response => response.data);
}

export function updateClientWebChatTriggerConf(id, data) {
    return request({
        method: 'PUT',
        data,
        baseURL: authURL,
        url: `/web-chat-configs/trigger/${id}`,
    }).then(response => response.data);
}

export function updateHardCodedMessage(clientId, topic, locale, text) {
    return request({
        method: 'PUT',
        data: {
            companyId: clientId,
            messageText: text,
            topic,
            locale,
        },
        baseURL: chatBackendURL,
        url: `/hardcoded/${clientId}`,
    }).then(response => response.data);
}

export function endSubCompanyUnmanagedConversationsWithMessage(clientId, message, endMin) {
    return request({
        method: 'POST',
        baseURL: chatBackendURL,
        headers: {
            'Content-Type': 'text/plain'
        },
        url: `/companies/${clientId}/sub-company/unmanaged/end-with-message`,
        params: {
            min: endMin
        },
        data: message
    }).then(response => response.data);
}

export function endParentCompanyUnmanagedConversationsWithMessage(clientId, message, endMin) {
    return request({
        method: 'POST',
        baseURL: chatBackendURL,
        headers: {
            'Content-Type': 'text/plain'
        },
        url: `/companies/${clientId}/parent-company/unmanaged/end-with-message`,
        params: {
            min: endMin
        },
        data: message
    }).then(response => response.data);
}

export function getClientExpirationTime(clientId) {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/expire/time/${clientId}`,
    }).then(response => response.data);
}

export function getAfkConfigByCompanyId(companyId) {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/chat-inactivity-action/${companyId}`,
    }).then(response => response.data);
}

export function setAfkConfigByCompanyId(companyId, afkConfig) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: `/chat-inactivity-action/${companyId}`,
        params: {
            enabled: afkConfig.enabled,
            afkTime: afkConfig.afkTime,
        },
    }).then(response => response.data);
}

export function getOperatorInactivityActionConfigByCompanyId(companyId) {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/operator-inactivity-action/${companyId}`,
    }).then(response => response.data);
}

export function setOperatorInactivityActionConfigCompanyId(companyId, operatorInactivityAction) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: `/operator-inactivity-action/${companyId}`,
        params: {
            enabled: operatorInactivityAction.enabled,
            text: operatorInactivityAction.text,
            time: operatorInactivityAction.time,
        },
    }).then(response => response.data);
}

export function getCompanyCategories(companyId) {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/category/${companyId}`,
    }).then(response => response.data);
}

export function getCompanyWorkingHours(companyId) {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/working-hours/${companyId}`,
    }).then(response => response.data);
}

export function updateCompanyWorkingHours(companyId, start, end) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: `/working-hours`,
        params: {
            companyId,
            start,
            end
        },
    }).then(response => response.data);
}

export function getCompanyReminderConfigs(companyId) {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/reminder/${companyId}`,
    }).then(response => response.data);
}

export function editCompanyReminderConfigs(companyId, reminderData) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: `/reminder/${companyId}`,
        data: reminderData
    }).then(response => response.data);
}

export function getCompanyMessageConfig(companyId) {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/message-config/${companyId}`,
    }).then(response => response.data);
}

export function updateCompanyMessageConfigDraftValue(companyId, operatorCanSeeDraftsValue) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: `/message-config/draft/${companyId}?operatorCanSeeDraftsValue=${operatorCanSeeDraftsValue}`,
    }).then(response => response.data);
}

export function updateCompanyEditMessageConfigValue(companyId, operatorCanEditMessageValue) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: `/message-config/edit/${companyId}?operatorCanEditMessageValue=${operatorCanEditMessageValue}`,
    }).then(response => response.data);
}

export function updateCompanyEditLimitConfigValue(companyId, editLimit) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: `/message-config/edit/limit/${companyId}?editLimit=${editLimit}`,
    }).then(response => response.data);
}

export function updateCompanyDeleteMessageConfigValue(companyId, operatorCanDeleteMessageValue) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: `/message-config/delete/${companyId}?operatorCanDeleteMessageValue=${operatorCanDeleteMessageValue}`,
    }).then(response => response.data);
}

export function updateExpirationTime(clientId, expireTime, isEnabled) {
    return request({
        method: 'PUT',
        data: {
            companyId: clientId,
            expireTime,
            enabled: isEnabled,
        },
        baseURL: chatBackendURL,
        url: `/expire/time/${clientId}`,
    }).then(response => response.data);
}

export function getTariffByStatus(tariffStatus) {
    return request({
        method: 'GET',
        baseURL: authURL,
        url: `/tariffs?${tariffStatus}`
    }).then(response => response.data)
}

export function handlePaymentResponse(payment) {
    return request({
        method: 'POST',
        baseURL: authURL,
        url: `/tariffs/pay/response`,
        data: payment
    })
}

export function calculateTariffPrice(tariffPackageId, tariffStatus, paymentPeriod, additionalOperators, additionalClients) {
    return request({
        method: 'GET',
        baseURL: authURL,
        url: `/tariffs/calculate?tariffPackageId=${tariffPackageId}&paymentPeriod=${paymentPeriod}&additionalOperators=${additionalOperators}&additionalClients=${additionalClients}&tariffStatus=${tariffStatus}`
    }).then(response => response.data)
}

export function pay(tariffStatus, isBinding, cardHolderId) {
    return request({
        method: 'POST',
        baseURL: authURL,
        url: `/tariffs/pay?tariffStatus=${tariffStatus}&isBinding=${isBinding}&cardHolderId=${cardHolderId}`
    })
}

export function editDraft(tariff) {
    return request({
        method: 'PUT',
        baseURL: authURL,
        data: tariff,
        url: `/tariffs/draft`
    })
}

export function confirm(tariffStatus) {
    return request({
        method: 'POST',
        baseURL: authURL,
        url: `/tariffs/confirm?tariffStatus=${tariffStatus}`,
    }).then(response => response.data)
}

export function editDraftTariff(tariffPackageId, tariffStatus, paymentPeriod, additionalOperators, additionalClients) {
    return request({
        method: 'PUT',
        baseURL: authURL,
        url: '/tariffs/draft',
        data: {
            tariffPackageId: tariffPackageId,
            paymentPeriod: paymentPeriod,
            additionalOperators: additionalOperators,
            additionalClients: additionalClients,
            tariffStatus: tariffStatus
        }
    }).then(response => response.data);
}

export function checkTariffLimit() {
    return request({
        method: 'GET',
        baseURL: authURL,
        url: '/tariffs/limit'
    })
}

export function bindCardRequest() {
    return request({
        method: 'POST',
        baseURL: authURL,
        url: '/card'
    })
}

export function deactivateBinding(cardHolderId) {
    return request({
        method: 'DELETE',
        baseURL: authURL,
        url: `/card?cardHolderId=${cardHolderId}`
    })
}

export function requestChangeActiveCard(cardHolderId) {
    return request({
        method: 'PUT',
        baseURL: authURL,
        url: `/card/active?cardHolderId=${cardHolderId}`
    })
}

export function changeAutoPayment(autoPaymentEnabled) {
    return request({
        method: 'PUT',
        baseURL: authURL,
        url: `/card/auto/payment?autoPaymentEnabled=${autoPaymentEnabled}`
    })
}

export function getUserByEmail(email) {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: '/operators/get-by-email',
        params: {
            email,
        },
    }).then(response => response.data);
}

export function getUserByEmails(emails) {
    return request({
        method: 'POST',
        baseURL: chatBackendURL,
        url: '/operators/get-by-emails',
        data: {
            emails,
        },
    }).then(response => response.data);
}

export function getUserByPlatform(platformId) {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: '/operators/get-by-platform',
        params: {
            platformId,
        },
    }).then(response => response.data);
}

export function getOperatorCurrentStatusHistory(startDateForCurrentStatus, endDateForCurrentStatus) {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/statistic/current-status-history`,
        params: {
            startDate: startDateForCurrentStatus,
            endDate: endDateForCurrentStatus
        },
    }).then(response => response.data);
}

export function getCategories(companyId) {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/category/${companyId}`,
    }).then(res => res.data);
}

export function getDailyChatLimit() {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/statistic/chats/get/daily-chats-limit`,
    }).then(response => response.data);
}

export function getCurrentChatLimit() {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/statistic/chats/get/current-chats-limit`,
    }).then(response => response.data);
}

export function getOperatorTickets() {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/tickets`,
    }).then(response => response.data);
}

export function deleteTicket(id) {
    return request({
        method: 'DELETE',
        baseURL: chatBackendURL,
        url: `/tickets/${id}`,
    }).then(response => response.data);
}

export function updateTicketStatus(id, status) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: `/tickets/status/${id}?status=${status}`,
    }).then(response => response.data);
}

export function updateTicketDescriptionAndAssignedUser(id, description, assignedUserPlatformId) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: `/tickets/description-and-assigned-user/${id}?description=${description}&userPlatformId=${assignedUserPlatformId}`,
    }).then(response => response.data);
}

export function addCompanyCategory(companyId, categoryName) {
    return request({
        method: 'POST',
        baseURL: chatBackendURL,
        url: `/category/${companyId}/${categoryName}`,
    }).then(response => response.data);
}

export function getConversationInfo(conversationId) {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/conversation-info/${conversationId}`,
    }).then(response => response.data);
}

export function moveConversationToUnManagedList(conversationId, silentMod) {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/conversations/${conversationId}/move-to-un-managed-list`,
        params: {
            silentMod
        },
    }).then(response => response.data);
}

export function saveConversationInfo(category, subject, description, priority, inProcess, isTicket, conversationId, assignee) {
    const data = {
        conversationId: conversationId,
        categoryId: category,
        subject: subject,
        priority: priority,
        inProcess: inProcess,
        ticket: isTicket,
        description: description,
        assignedUserPlatformId: assignee
    }
    return request({
        method: 'POST',
        baseURL: chatBackendURL,
        url: `/conversation-info`,
        data: data,
    })
        .then(response => response);
}

export function deleteCompanyCategory(companyId, categoryName) {
    return request({
        method: 'DELETE',
        baseURL: chatBackendURL,
        url: `/category/${companyId}/${categoryName}`,
    }).then(response => response.data);
}

export function editCompanyCategory(companyId, categoryId, isEnabled) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: `/category/${companyId}/${categoryId}?isEnabled=${isEnabled}`,
    }).then(response => response.data);
}

export function getTemplates(companyId) {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/template/${companyId}`,
    }).then(response => response.data);
}

export function addTemplate(companyId, text, folderName) {
    return request({
        method: 'POST',
        baseURL: chatBackendURL,
        url: '/template',
        headers: {
            'Content-Type': 'text/plain'
        },
        params: {
            companyId,
            folderName
        },
        data: text
    }).then(response => response.data);
}

export function importTemplatesF(companyId, originalCompanyId, folderName) {
    return request({
        method: 'POST',
        baseURL: chatBackendURL,
        url: '/template/import',
        headers: {
            'Content-Type': 'text/plain'
        },
        params: {
            companyId,
            originalCompanyId,
            folderName
        },
    }).then(response => response.data);
}

export function editTemplate(companyId, text, folderName, id) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: '/template',
        headers: {
            'Content-Type': 'text/plain'
        },
        params: {
            companyId,
            folderName,
            id
        },
        data: text
    }).then(response => response.data);
}

export function deleteTemplate(companyId, templateId) {
    return request({
        method: 'DELETE',
        baseURL: chatBackendURL,
        url: '/template',
        params: {
            companyId, templateId
        },
    }).then(response => response.data);
}

export function getOperatorHotkeysConfig() {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/hotkey-config`,
    }).then(response => response.data);
}

export function saveHotkeysConfig(requests) {
    return request({
        method: 'POST',
        baseURL: chatBackendURL,
        url: `/hotkey-config`,
        data: requests

    }).then(response => response.data);
}

export function getCustomTemplates() {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/custom-template`,
    }).then(response => response.data);
}

export function addCustomTemplate(text) {
    return request({
        method: 'POST',
        baseURL: chatBackendURL,
        url: '/custom-template',
        headers: {
            'Content-Type': 'text/plain'
        },
        data: text
    }).then(response => response.data);
}

export function editCustomTemplate(id, text) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: '/custom-template',
        headers: {
            'Content-Type': 'text/plain'
        },
        params: {
            id
        },
        data: text
    }).then(response => response.data);
}

export function deleteCustomTemplate(customTemplateId) {
    return request({
        method: 'DELETE',
        baseURL: chatBackendURL,
        url: '/custom-template',
        params: {
            customTemplateId
        },
    }).then(response => response.data);
}

export function getWebhooks(companyId) {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/webhook/${companyId}`,
    }).then(response => response.data);
}

export function addWebhook(companyId, api, token, type, headerName) {
    return request({
        method: 'POST',
        baseURL: chatBackendURL,
        url: '/webhook',
        params: {
            companyId,
            api,
            token,
            headerName,
            type
        },
    }).then(response => response.data);
}

export function deleteWebhook(companyId, webhookId) {
    return request({
        method: 'DELETE',
        baseURL: chatBackendURL,
        url: '/webhook',
        params: {
            companyId, webhookId
        },
    }).then(response => response.data);
}


export function getSkills(companyId) {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/skill/${companyId}`,
    }).then(response => response.data);
}

export function addSkill(companyId, name) {
    return request({
        method: 'POST',
        baseURL: chatBackendURL,
        url: '/skill',
        headers: {
            'Content-Type': 'text/plain'
        },
        params: {
            companyId
        },
        data: name
    }).then(response => response.data);
}

export function deleteSkill(companyId, skillId) {
    return request({
        method: 'DELETE',
        baseURL: chatBackendURL,
        url: '/skill',
        params: {
            companyId, skillId
        },
    }).then(response => response.data);
}

export function updateSkill(companyId, skillId, newName) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: '/skill',
        headers: {
            'Content-Type': 'text/plain'
        },
        params: {
            companyId, skillId
        },
        data: newName
    }).then(response => response.data);
}

export function signSkillToOperator(operatorId, skillId) {
    return request({
        method: 'POST',
        baseURL: chatBackendURL,
        url: `/operators/skill/${operatorId}/${skillId}`,
        headers: {
            'Content-Type': 'text/plain'
        },
    }).then(response => response.data);
}

export function deleteSkillFromOperator(operatorId, skillId) {
    return request({
        method: 'DELETE',
        baseURL: chatBackendURL,
        url: `/operators/skill/${operatorId}/${skillId}`,
        headers: {
            'Content-Type': 'text/plain'
        },
    }).then(response => response.data);
}


export function getCompanyBlackList(companyId) {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/black-list/${companyId}`,
    }).then(response => response.data);
}

export function addUserToBlackList(blackListEntity, companyId, conversationId) {
    return request({
        method: 'POST',
        baseURL: chatBackendURL,
        url: `/black-list/${companyId}`,
        data: blackListEntity,
        params: {
            conversationId
        }
    }).then(response => response);
}

export function deleteUserFromBlackList(id, companyId) {
    return request({
        method: 'DELETE',
        baseURL: chatBackendURL,
        url: `/black-list/${id}/${companyId}`,
    }).then(response => response.data);
}


export function getCompanyInitialMessage(companyId) {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/initial-message/${companyId}`,
    }).then(response => response.data);
}

export function addCompanyInitialMessage(initialMessage, companyId) {
    return request({
        method: 'POST',
        baseURL: chatBackendURL,
        url: `/initial-message/${companyId}`,
        data: initialMessage
    }).then(response => response.data);
}

export function editCompanyInitialMessage(initialMessage, companyId) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: `/initial-message/${companyId}`,
        data: initialMessage
    }).then(response => response.data);
}

export function deleteCompanyInitialMessage(id, companyId) {
    return request({
        method: 'DELETE',
        baseURL: chatBackendURL,
        url: `/initial-message/${id}/${companyId}`,
    }).then(response => response.data);
}

export function getCompanyInfo(id) {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/company-info/${id}`,
    }).then(response => response.data);
}


export function updateAiDescription(id, description) {
    return request({
        method: 'PUT',
        headers: {
            'Content-Type': 'text/plain'
        },
        baseURL: chatBackendURL,
        url: `/company-info/AI-description/${id}`,
        data: description
    }).then(response => response.data);
}

export function updateAiType(id, type) {
    return request({
        method: 'PUT',
        headers: {
            'Content-Type': 'text/plain'
        },
        baseURL: chatBackendURL,
        url: `/company-info/AI-type/${id}`,
        data: type
    }).then(response => response.data);
}

export function updateAiContentLoadingHours(id, hours) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: `/company-info/ai-content-loading-hours/${id}?aiContentLoadingHours=` + hours,
    }).then(response => response.data);
}

export function updateAiHumanOnlyHours(id, hours) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: `/company-info/ai-human-only-hours/${id}?aiHumanOnlyHours=` + hours,
    }).then(response => response.data);
}





// WEBPACK FOOTER //
// ./src/services/company/api.js